export const SAVE_SELFIE = 'SAVE_SELFIE'
export const RESET_SELFIE = 'RESET_SELFIE'

export const saveSelfie = (selfie) => ({ type: SAVE_SELFIE, selfie })
export const resetSelfie = () => ({ type: RESET_SELFIE })